module.exports = __webpack_public_path__ + "static/media/fit-branco.b3e9cd2e.webp";